import { render, staticRenderFns } from "./BookingEditShortlist.vue?vue&type=template&id=31dceb42"
import script from "./BookingEditShortlist.vue?vue&type=script&lang=js"
export * from "./BookingEditShortlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports